import { useEffect } from "react";
import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, Divider, Alert, Select, MenuItem } from '@mui/material';
import { useQueueManager } from './hooks/useQueueManager';
import { QueueManagerProps } from "./types";
import { queueManagerActions } from "../../../util/DataObject";


export const QueueManager = ({ open, changeAlert, changeLoader }: QueueManagerProps & DefaultComponentProps) => {
    const { form, zPos, action, loading: loadingTable, isValidForm, onHandleChange, onConfirm, onClose, setAction, setForm } = useQueueManager(open, changeAlert);

    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
    useEffect(() => {
        setForm({});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [action]);

    return (
        <Dialog onClose={onClose} open={open} style={{ display: zPos !== 45 ? "none" : null, minWidth: "600px", maxHeight: "600px" }}>
            <DialogTitle>
                <Typography variant='h2'>Queue Manager</Typography>
            </DialogTitle>

            <DialogContent style={{paddingTop: 30}}>
                <Alert severity={"info"}>Seleccione la acción a ejecutar</Alert>
                <Select value={action || '-1'} onChange={(e) => setAction(e.target.value)} MenuProps={{style: {zIndex: 35001}}} sx={{mt: 2, mb: 1}} fullWidth variant="outlined" size='small' >
                    <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                    {queueManagerActions?.map((item, index) => {
                        return <MenuItem key={`option-${index}`} value={item.key}>{item.label}</MenuItem>
                    })}
                </Select>
                { action &&
                    <>
                        <Divider sx={{my: 1}}/>
                        <TextField sx={{my: 1}}
                            label="Queue ID" value={ (form && form['queue_id']) || ''} onChange={onHandleChange.bind(this, "queue_id")} fullWidth size='small'
						/>
                        {action === "queueManagerActivate" && <Select size='small'
                            value={(form && form.hasOwnProperty('active') && String(form['active'])) || '-1'} 
                            onChange={onHandleChange.bind(this, "active" )} MenuProps={{style: {zIndex: 35001}}} sx={{my: 1}} fullWidth variant="outlined" >
                            <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                            <MenuItem value={"true"}>Activo</MenuItem>
                            <MenuItem value={"false"}>Inactivo</MenuItem>
                        </Select>}
                        {action === "queueManagerUpdateRate" && <TextField sx={{my: 1}} type={"number"} size='small'
                            label="Límite por minuto" value={ (form && form['task_per_minute']) || 0} onChange={onHandleChange.bind(this, "task_per_minute")} fullWidth 
						/>}
                    </>
                
                }
            </DialogContent>

            <DialogActions>
                <FlexGrid fullHeight fullWidth justify='space-between' alignItems='space-between' style={{ marginTop: '20px', display: 'flex' }}>
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item style={{textAlign: 'end'}}>
                        <Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
                            Ejecutar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}

export default QueueManager;
